import generalSettingsImg from 'assets/images/settings.png';
import securitySettingsImg from 'assets/images/security_settings.png';
import advancedSettingsImg from 'assets/images/advanced_settings.png';

const settingsMenuItems = {
    id: 'settings',
    title: 'Settings',
    type: 'group',
    required: {
        server_admin: true,
        org_admin: true
    },
    children: [
        {
            id: 'settings-general',
            title: 'General',
            type: 'item',
            icon: generalSettingsImg,
            url: '/settings/general',
            breadcrumbs: false
        },
        {
            id: 'settings-security',
            title: 'Security',
            type: 'item',
            icon: securitySettingsImg,
            url: '/settings/security',
            breadcrumbs: false
        },
        {
            id: 'settings-advanced',
            title: 'Advanced',
            type: 'item',
            url: '/settings/advanced',
            icon: advancedSettingsImg,
            breadcrumbs: false
        }
    ]
};

export default settingsMenuItems;
